var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.canEdit)?_c('NotificationEmployeeTerminated'):_vm._e(),_c('ComplianceProfile',{attrs:{"type":_vm.type,"can-edit":_vm.canEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }